import type { DpEvent } from '@/core/events/DpEvent';

export class FacilityUnloadedEvent implements DpEvent {
  static readonly eventName = 'FacilityUnloaded';

  readonly name = FacilityUnloadedEvent.eventName;
}
